import "./broadcasterCardDisplay.css";
import { useTranslation } from "react-i18next";

const BroadcasterCardDisplay = ({ broadcasterObject }) => {
    const { t } = useTranslation("moderatorPage");
    const broadcasterUrl = broadcasterObject
        ? broadcasterObject.broadcasterImageURL
        : "/imageNotFound.jpg";
    const broadcastername = broadcasterObject
        ? broadcasterObject.broadcasterUsername
        : "Unkown";
    const mayApproveMemes = broadcasterObject
        ? broadcasterObject.approveDenyPermission
            ? t("moderatorYes")
            : t("moderatorNo")
        : t("moderatorNo");

    return (
        <>
            <div className="broadcasterCardDisplayContainer">
                <div className="broadcasterCardDisplayImageNameContainer">
                    <img
                        src={broadcasterUrl}
                        className="broadcasterCardDisplayImage"
                        alt={broadcasterUrl}
                    />
                    <p className="broadcasterCardDisplayName">
                        {broadcastername}
                    </p>
                </div>

                <hr className="broadcasterCardDisplayHr"></hr>
                <div className="broadcasterCardDisplayPremissionsContainer">
                    <h2>{t("moderatorPremissionsTitle")}</h2>
                    <div className="broadcasterCardDisplayContainerApproveDeny">
                        <h4>
                            {t("mayApproveAndDenyMemes", { mayApproveMemes })}
                        </h4>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BroadcasterCardDisplay;
